<template>
  <div>
    <div class="indexsearch">
      <div class="title">Transformers Explorer</div>
      <div class="seacherc">
        <input
          type="text"
          id="inputvalue"
          v-model.trim="value"
          @keyup.enter="search"
          placeholder="Search by Address/Txn Hash/Block"
        />
        <div class="button" @click="search">
          <img src="../../../assets/pc/seach/seach.png" />
        </div>
      </div>
    </div>
    <!-- <div class="HomeW-inp">
      <input
        type="text"
        placeholder="Search by Address / Txn Hash / Block "
        v-model.trim="value"
        @keyup.enter="search"
        id="inputvalue"
      />
      <i class="iconfont"
        ><img src="@/assets/pc/TopValidators/fangdajing.svg" alt=""
      /></i>
    </div> -->
  </div>
</template>

<script>
import { GetSearchKey } from "@/assets/server/api";
export default {
  data() {
    return {
      value: "",
      standard:""
    };
  },
  methods: {
    search() {
      var inputvalue = document.getElementById("inputvalue");
      if (inputvalue.innerHTML == " ") {
        return;
      }
      if (this.value == "") {
        return;
      } else if (this.value != "") {
        this.$emit("search", this.value);
        const params = {
          key: this.value,
          pageNum: 1,
          pageSize: 10,
        };
        console.log(params);
        const formData = new FormData();
        const item = params;
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            formData.append(key, item[key]);
          }
        }
        GetSearchKey(formData).then((res) => {
         console.log(res);
          this.standard=res.result.standard;
          if (res.code == 200) {
            let types = res.result.searchType;
        //    console.log(types);
            var typelist = res.result.type;
       //     console.log(typelist);
            switch (types) {
              case "addressDetail":
                let params1 = {
                  address: this.value,
                };
                if (this.value == "") {
                  return false;
                } else {
                  this.$emit("search", params1);
                  this.$router.push({
                    path: "/pc/BkHash",
                    query: {
                      query: this.value,
                    },
                  });
                }
                break;
              case "transactionDetail-contractTransfer":
                let params2 = {
                  txHash: this.value,
                  type: typelist,
                  standard:this.standard
                };
                this.$emit("search", params2);
                this.$router.push({
                  path: "/pc/To",
                  query: params2,
                });
                break;
              case "transactionDetail-contractCreate":
                let params3 = {
                  txHash: this.value,
                  type: typelist,
                  standard:this.standard
                };
                this.$emit("search", params2);
                this.$router.push({
                  path: "/pc/To",
                  query: params3,
                });
                break;
              case "transactionDetail-MainNetTransfer":
                let params4 = {
                  txHash: this.value,
                  type: typelist,
                  standard:this.standard
                };
                this.$emit("search", params2);
                this.$router.push({
                  path: "/pc/To",
                  query: params4,
                });
                break;
              case "transactionDetail-Bonus":
                let params5 = {
                  txHash: this.value,
                  type: typelist,
                };
                this.$emit("search", params5);
                this.$router.push({
                  path: "/pc/To",
                  query: params5,
                  standard:this.standard
                });
                break;
              // transactionDetail-contractCreate
              //transactionDetail-MainNetTransfer
              case "heightDetail":
                let params = {
                  blockHeight: res.result.blockHeight,
                };
                this.$emit("search", params);
                this.$router.push({
                  path: "/pc/BkHeight",
                  query: {
                    height: this.value,
                  },
                });
                break;
            }
            this.value = "";
          } else if (res.code == 400) {
            this.$router.push({
              path: "/pc/404",
            });
          }
        });
      }
    },
  },
};
</script>
<style>


</style>
<style lang="less" scoped>
.indexsearch {
  width: 50%;
  background: #13161b;
  .title {
    width: 238px;
    height: 32px;
    font-size: 22px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    line-height: 32px;
  }
  .seacherc {
    margin-top: 20px;
    width: 580px;
    height: 40px;
    line-height: 40px;
    background: #000000;
    border-radius: 10px 10px 10px 10px;
    display: flex;
    opacity: 1;
    input {
      width: 100%;

      border-radius: 8px 8px 8px 8px;
      border: none;
      padding: 0 20px;
      font-size: 12px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color:#fff;

      line-height: 24px;
      -webkit-background-clip: text;
    }
    
    .button {
      width: 40px;
      height: 40px;
      background: #00e79a;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      img {
        width: 16px;
        height: 17px;
        // padding: 20px 12px;
        margin-top: 12px;
        margin-left: 12px;
      }
    }
  }
}

// @import url("https://at.alicdn.com/t/font_3404326_3s5grzrpcqy.css");
// .HomeW-inp {
//   position: relative;
//   background-color: #232a35;
//   border-radius: 8px 8px 8px 8px;
//   input {
//     width: 100%;
//     height: 56px;

//     border-radius: 8px 8px 8px 8px;
//     border: 1px solid #232a35;
//     padding: 0 56px;
//     font-size: 16px;
//     font-family: SF Pro Text-Medium, SF Pro Text;
//     font-weight: 500;
//     color: rgba(255, 255, 255, 0.35);
//     line-height: 24px;
//     -webkit-background-clip: text;
//   }
//   i {
//     position: absolute;
//     top: 18px;
//     left: 24px;
//     img {
//       width: 24px;
//       height: 24px;
//     }
//   }
// }
</style>
